import {
  getCampaignAudienceExport,
  getCampaignExport,
  getExcelTemplate,
} from "../api/Services";

export const handleDownloadTemplate = async (
  type: string,
  setLoading?: (loading: boolean) => void
) => {
  if (setLoading) setLoading(true);
  const response = await getExcelTemplate(type);

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const url = URL.createObjectURL(
    new Blob([response.data], { type: fileType })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", response.filename || "Excel.xlsx");
  document.body.appendChild(link);
  link.click();
  if (setLoading) setLoading(false);
};

function sanitizeFilename(name: string | null | undefined): string {
  if (name == null || typeof name !== "string" || !name.trim()) return "";
  return name.replace(/[\\/:*?"<>|]/g, "_").trim();
}

export const handleDownloadCampaignExport = async (
  campaignId: number,
  setLoading?: (loading: boolean) => void,
  campaignName?: string | null
) => {
  if (setLoading) setLoading(true);
  const response = await getCampaignExport(campaignId);
  if (response.success && response.data) {
    const baseName = sanitizeFilename(campaignName);
    const filename =
      baseName ? `${baseName}.xlsx` : response.filename || `Datos_campana_${campaignId}.xlsx`;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const url = URL.createObjectURL(new Blob([response.data], { type: fileType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  if (setLoading) setLoading(false);
  return response.success;
};

export const handleDownloadCampaignAudienceExport = async (
  campaignId: number,
  setLoading?: (loading: boolean) => void,
  campaignName?: string | null
) => {
  if (setLoading) setLoading(true);
  const response = await getCampaignAudienceExport(campaignId);
  if (response.success && response.data) {
    const baseName = sanitizeFilename(campaignName);
    const filename =
      response.filename ||
      (baseName
        ? `Audiencia_${baseName}.csv`
        : `Audiencia_campana_${campaignId}.csv`);
    const fileType = "text/csv;charset=UTF-8";
    const url = URL.createObjectURL(new Blob([response.data], { type: fileType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  if (setLoading) setLoading(false);
  return response.success;
};

export const downloadFile = (
  content: string,
  fileName: string,
  fileType: string
) => {
  const a = document.createElement("a");
  const file = new Blob([content], { type: fileType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
};
